import { SequenceEntity } from '@/interfaces';
import { IVolumeToSendOutDto } from '@/pages/authenPages/Sequencing/SequencingDetail/dtos/volume-to-send-out.dto';
import { DefaultEntity, SequenceParams } from '@/types';
import { HttpStatusCode } from 'axios';
import APIService from './axios.service';
import { BaseService } from './base.service';

class SequenceService extends BaseService<
  'sequence',
  SequenceEntity,
  DefaultEntity
> {
  constructor() {
    super('sequences');
  }

  getSequences = (params: SequenceParams): Promise<SequenceEntity[]> =>
    APIService.get(this.path, { params });

  updateVolumeToSendOut = (
    payload: IVolumeToSendOutDto,
  ): Promise<HttpStatusCode> =>
    APIService.patch(this.path + '/volume-to-send-out', payload);

  updateMultipleSequencesStatus = (payload: {
    ids: string[];
    qcFailReason?: string;
    status: string;
    shouldNotAddHistory?: boolean;
  }): Promise<HttpStatusCode> => {
    return APIService.patch(
      this.path + '/update-multiple-sequences-status',
      payload,
    );
  };

  trigger16sPipeline = (sequenceNumberOrId: string): Promise<unknown> =>
    APIService.post(`${this.path}/${sequenceNumberOrId}/trigger-16s-pipeline`);
}

export const sequenceService = new SequenceService();
